export class FixedExtend {

    //修改round函数赔率修改
    toFixedExprend(odds, length) {
        let str = odds + ''; //将调用该方法的数字转为字符串
        let multiple = Math.pow(10, length); //设置浮点数要扩大的倍数
        let carry = 0;
        var decimalpoint = str.indexOf("."); //找到小数点的位置
        let mantissa = parseFloat(str.substr(decimalpoint + length + 1, 1));  //尾数
        if (mantissa >= 6) { //当尾数位 >=6的时进位
            carry = 1;
        } else if (mantissa <= 4) {  //当尾数位 <=4 的时不进位
            carry = 0;
        } else if (mantissa == 5) {
            let afterMantissa = str.substr(decimalpoint + length + 2, str.length - 1);  //尾数后面的数字
            afterMantissa = afterMantissa == "" ? "0" : afterMantissa;
            // 当尾数为5，而尾数“5”的后面还有任何不是0的数字时，无论前一位在此时为奇数还是偶数，也无论“5”后面不为0的数字在哪一位上，都应向前进一位。
            if (parseFloat(afterMantissa) != 0) {
                carry = 1;
            } else {
                let beforeMantissa = str.substr(decimalpoint + length, 1); //尾数前一位数
                if (parseFloat(beforeMantissa) % 2 != 0) {
                    carry = 1;
                }
            }
        }
        let num = Math.floor(this.accMul(odds, multiple)) + carry; //去掉舍入位后的所有数，然后加上我们的手动进位数
        let result = this.accDiv(num, multiple) + ''; //将进位后的整数再缩小为原浮点数
        /*
       * 处理进位后无小数
       */
        let dot = result.indexOf(".");
        if (dot < 0) {
            result += '.';
            dot = result.indexOf(".");
        }
        /*
        * 处理多次进位
        */
        let len = result.length - (dot + 1);
        if (len < length) {
            for (let i = 0; i < length - len; i++) {
                result += 0;
            }
        }
        return result;
    }

    /** 
     ** 除法函数，用来得到精确的除法结果
     ** 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
     ** 调用：accDiv(arg1,arg2)
     ** 返回值：arg1除以arg2的精确结果
     **/
    accDiv(arg1, arg2) {
        var t1 = 0, t2 = 0, r1, r2;
        try {
            t1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
        }
        try {
            t2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
        }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return this.accMul((r1 / r2), Math.pow(10, t2 - t1));

    }

    /**
     ** 乘法函数，用来得到精确的乘法结果
     ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
     ** 调用：accMul(arg1,arg2)
     ** 返回值：arg1乘以 arg2的精确结果
     **/
    accMul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        }
        catch (e) {
        }
        try {
            m += s2.split(".")[1].length;
        }
        catch (e) {
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    }

    /**
     ** 减法函数，用来得到精确的减法结果
    ** 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
    ** 调用：accSub(arg1,arg2)
    ** 返回值：arg1加上arg2的精确结果
    **/
    accSub(arg1, arg2) {
        var r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    }


    /**
     ** 加法函数，用来得到精确的加法结果
     ** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
     ** 调用：accAdd(arg1,arg2)
     ** 返回值：arg1加上arg2的精确结果
     **/
    accAdd(arg1, arg2) {
        var r1, r2, m, c;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        c = Math.abs(r1 - r2);
        m = Math.pow(10, Math.max(r1, r2));
        if (c > 0) {
            var cm = Math.pow(10, c);
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""));
                arg2 = Number(arg2.toString().replace(".", "")) * cm;
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm;
                arg2 = Number(arg2.toString().replace(".", ""));
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", ""));
        }
        return (arg1 + arg2) / m;
    }
}


// WEBPACK FOOTER //
// ./src/config/fixed-extend.ts